import styled from "styled-components";

export const CloseIconWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    display: flex;
  }
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: #fff;
    }
  }
  &:hover {
    opacity: 0.8;
  }
`;
export const ContextMenuButton = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 101;
  width: 40px;
  height: 56px;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    display: flex;
  }
`;

export const SidebarWrapper = styled.div`
  padding: 40px;
  opacity: 1;
  transition: opacity 0.15s linear;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.primary600};
  color: ${({ theme }) => theme.colors.white};
  font-family: "Inter", sans-serif;
  height: 100%;
  overflow-y: auto;
`;

export const CompanyInfoCard = styled.div`
  margin-bottom: 16px;
  margin-top: 20px;
  background-color: ${({ theme }) => theme.colors.primary500};
  border-radius: 8px;
  padding: 20px;
  gap: 32px;
  display: flex;
  flex-direction: column;
`;

export const SidebarContainer = styled.div<{ open: boolean; width: number }>`
  width: ${({ open, width }) => (open ? `${width}px` : "0")};
  background: #312e5f;
  color: white;
  height: 100vh;
  overflow: hidden;
  transition: width 0.3s;
  box-sizing: border-box;
  position: absolute;
  z-index: 1000;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: ${({ open, width }) => (open ? `100%` : "0")};
    position: fixed;
    z-index: 1000;
  }
`;

export const ArrowButton = styled.div<{ open: boolean }>`
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 100;
  width: 40px;
  height: 56px;
  background: #312e5f;
  border-radius: 0 8px 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    display: none;
  }
`;

export const ArrowIcon = styled.div<{ open: boolean }>`
  width: 28px;
  height: 28px;
  color: white;
  transition: transform 0.3s;
  transform: ${({ open }) => (open ? "rotate(0deg)" : "rotate(180deg)")};
  svg {
    width: 28px;
    height: 28px;
  }
`;

export const LanguageSelectorWrapper = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  width: 160px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 140px;
  }
`;

export const MainContent = styled.div<{ open: boolean; width: number }>`
  transition: margin-left 0.3s;
  padding: 20px;
  position: relative;
  width: calc(100% - ${({ open, width }) => (open ? `${width}px` : "0px")});
  margin-left: ${({ open, width }) => (open ? `${width}px` : "0px")};
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const MainContentInner = styled.div`
  padding-top: 80px;
`;

export const Label = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.netural100};
`;

export const Text = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  display: block;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.primary100};
`;

export const StatusDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.primary100};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-wrap: auto;
  min-width: 280px;
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  width: 500px;
  gap: 24px;
  border: 1px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.white};
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
  }
`;

export const EmptyStateText = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.netural800};
  text-align: center;
  font-family: "Inter", sans-serif;
`;
